// import { sortableContainer } from 'react-sortable-hoc';

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Dropdown, { INSIGHTS } from './insightsDropdown';
// import GuidingPrinciples from './guidingPrinciples';
import InsightList from './insightsList';
import actions from '@flux/action';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
} from '@dnd-kit/sortable';
import { USER_PERMISSION_MODEL } from '@model/userPermission';
// import '@style/modules/insights/insights.scss';
import '../../styles/modules/insights/insights.scss';

const Insights = (props) => {
  const { fetchData, changeOrderAndRefetch } = props;
  const {
    principleData,
    insightsData,
    projectId,
    permission,
    userInfo: { role },
  } = props;

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 50,
      },
    }),
    useSensor(KeyboardSensor),
  );

  useEffect(() => {
    fetchData(projectId);
  }, []);

  const handleDragEnd = async (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return;
    }

    // Extract collection and index from the ID
    const [activeCollection, activeIndex] = active.id.split('-');
    const [overCollection, overIndex] = over.id.split('-');

    if (activeCollection !== overCollection) {
      return;
    }

    const oldIndex = parseInt(activeIndex);
    const newIndex = parseInt(overIndex);

    function restruct(obj) {
      const _obj = arrayMove(obj, oldIndex, newIndex);
      return _obj.map((e) => e.id || e.insightId);
    }

    switch (activeCollection) {
      case 'gd':
        await changeOrderAndRefetch(
          'guidingPrinciple',
          restruct(principleData),
        );
        break;
      case 'insight':
        await changeOrderAndRefetch('insight', restruct(insightsData));
        break;
      default:
        return;
    }
    fetchData(projectId);
  };

  const pageComp = (type, data) => {
    if (
      role === 'client' &&
      !permission.includes(USER_PERMISSION_MODEL.INSIGHT.insights)
    ) {
      return null;
    }
    return <InsightList data={data} />;
  };

  // Create items array for SortableContext
  const items = insightsData.map((_, index) => `insight-${index}`);

  return (
    <div className="insights-container">
      <Dropdown section={INSIGHTS} />

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext items={items} strategy={rectSortingStrategy}>
          {pageComp('insight', insightsData)}
        </SortableContext>
      </DndContext>
    </div>
  );
};

const mapStateToProps = ({ common, insights, projects, login }) => {
  const projectId = common.currentId;

  const { principleData = [], insightsData = [] } =
    insights.insightsData[projectId] || {};
  return {
    principleData,
    insightsData,
    projectId,
    permission: projects.sectionsPermission.insightPermission,
    userInfo: login.userInfo || {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  async fetchData(params) {
    await dispatch(
      // the second param won't influence result
      actions.fetchGdPrincipleAndInsightstData(params, 'Integration'),
    );
  },
  async changeOrderAndRefetch(insightId, newIndex) {
    await dispatch(actions.changeOrderAndRefetch(insightId, newIndex));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(Insights));
